<template>
  <div class="content">
    <van-nav-bar
      :title="$lang.authName_title"
      :border="false"
      fixed
      z-index="99999"
      @click-left="onClickLeft"
    >
      <template v-if="$route.query.from !== 'recharge'" #left>
        <van-icon name="arrow-left" size="20" color="#1F2A47" />
      </template>
    </van-nav-bar>
    <div class="content-bank--c m-t-10">
      <van-field
        v-model="realName"
        :placeholder="$lang.authName_txt"
        class="custom-field"
        :style="{ borderColor: focus ? '#076237' : '#494949' }"
        @focus="focus = true"
        @blur="focus = false"
      >
      </van-field>
      <p class="error-color m-t-10 m-l-5">
        {{ $lang.authName_txt2 }}
      </p>
      <van-button
        @click="submit"
        size="large"
        class="custom-button m-t-20"
        :disabled="submitting"
      >
        {{ $lang.Enviar }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { RealnameCert } from '@/api/common'
import { failMessage, handleNeedLogin, isSafeWriteSuccess } from './safeFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

export default {
  name: 'AuthName',
  components: {},
  data() {
    return {
      focus: false,
      realName: '',
      submitting: false
    }
  },
  mounted() {},
  methods: {
    ensureLogin() {
      if (safeGetStorageItem(getLocalStorage(), 'token')) return true
      if (this.$bus) this.$bus.$emit('openLogin')
      this.$jumpTo('/home', {}, { replace: true })
      return false
    },
    async submit() {
      if (this.submitting) return
      if (!this.ensureLogin()) return
      if (!this.realName) {
        this.$toast({
          message: this.$lang.authName_txt3,
          icon: 'cross'
        })
        return
      }

      this.submitting = true
      try {
        const data = await RealnameCert({ realName: this.realName })
        if (handleNeedLogin(this, data)) return
        if (isSafeWriteSuccess(data)) {
          if (this.$route.query.from === 'recharge') {
            this.$jumpTo('/setPassWord', { from: 'recharge' })
          } else {
            this.$router.go(-1)
          }
        } else {
          this.$toast({
            message: failMessage(data),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: failMessage(e, '实名认证提交失败，请稍后重试。'),
          icon: 'cross'
        })
      } finally {
        this.submitting = false
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 60px 3% 0 3%;
  background: white;
}

.custom-field2 {
  margin-top: 10px;
  padding: 11px 15px;
  font-size: var(--vk-fs-15);
  background: white;
  border-radius: 13px;
  border: 1px solid #cecece;
  font-weight: normal !important; // 👈 添加这句确保外层不加粗
  ::v-deep .van-field__control {
    color: #333333; // 输入文字颜色
    font-size: var(--vk-fs-15);
    font-weight: normal !important; // 👈 添加这句确保外层不加粗

    &::placeholder {
      color: #999 !important;
      font-weight: normal !important; // 👈 添加这句确保外层不加粗
    }
  }
}
</style>
